import {useState, useEffect} from 'react';
import TableRows from './Rows/TableRows';
import TableHeader from './Rows/TableHeader';
import Pagination from '../components/Pagination';
import UserInfoTable from './UserInfoTable';
import UserDecodersList from './UserDecodersList';
import Payments from './../Payments/Payments';
import AddUser from './Adder/AddUser'
import './css/Subscribers.css';
import './css/SubscribersProfile.css'
import { fetchSubscribersList, fetchUser } from './../service/subscribers/subscribersApi';
import { two, four } from './../service/rights';

import { fetchPaymentsData } from './../service/payments/comp';
import testData from './testData.json';
// const regionL = [{region_id: 1, region_name: "Tbilisi"}, {region_id: 2, region_name: "Tbilisi"}, {region_id: 3, region_name: "Tbilisi"}];
const columnsR = [{ id: 'user_id', label: 'User ID', }, { id: 'email', label: 'Email', }, { id: 'name', label: 'User Name', }, { id: 'phone', label: 'Phone', }, { id: 'region', label: 'Region', }, { id: 'btn', label: ' ', }];  
const columns = [{ id: 'user_id', label: 'User ID', }, { id: 'email', label: 'Email', }, { id: 'name', label: 'User Name', }, { id: 'phone', label: 'Phone', }, { id: 'region', label: 'Region', }];  

const Subscribers = ({regions, domain, dataL, setDataL, selfRightsLvl, currenciesL}) => {
    const [subscribersData, setSubscribersData] = useState(dataL);
    const [pageNumber, setPageNumber] = useState(0);

    const [name, setName] = useState(null);
    const [phone, setPhone] = useState(null);
    const [email, setEmail] = useState(null);
    const [regionId, setRegionId] = useState(null);
    const [decoderId, setDecoderId] = useState(null);

    const [info, setShowInfo] = useState(false);
    const [showPayments, setShowPayments] = useState(false);
    const [payments, setPayments] = useState({});
    const [balance, setBalance] = useState(0);
    const getPayments = async (userEmail, user_id) => {
      fetchPaymentsData(user_id, userEmail, null, null, 0, setPayments, domain)
    }
    const paymentsState = () => {
      setShowPayments(!showPayments);
    }
    const [user, setUserInfo] = useState({});    
    const [userId, setUserId] = useState(0);
    const [requestId, setRequestId] = useState(0);
    ////////////////
    // Fetching functions     
    const fetchUserData = async (index) => {
      try{
        const data = await fetchUser(index);
        setUserInfo(data || {});
        setUserId(index);
      }catch(e){
        console.error(e.message)
      }
    }
    ////////////////
    // page loading 
    const pageCount = Math.ceil(subscribersData?.count !== null ? subscribersData.count / 10 : 0);

    ////////////////
    // actions
    const fillForms = (param, value) => {
      switch (param) {
        case 'user_id':
          setRequestId(parseInt(value == "" ? null : value, 10));
          break;
        case 'name':
          setName(value == "" ? null : value);
          break;
        case 'email':
          setEmail(value == "" ? null : value);
          break;
        case 'phone':
          setPhone(value == "" ? null : value);
          break;
        case 'decoder_id':
          setDecoderId(value == "" ? null : value)
        default:
          break;
      }
    }
    const handleShowUserInfo = (index, userEmail) => { 
      setShowInfo(true);
      setShowPayments(false)
      getPayments(userEmail, index);
      fetchUserData(index);
    }

    const fetchList = async () => {
      const data = await fetchSubscribersList({
        user_id: requestId,
        name,
        email,
        phone,
        regionId,
        decoderId
      }, pageNumber);
      setSubscribersData(data);
    }

    useEffect(() =>{
      fetchList();
      setShowInfo(false);
    }, [pageNumber])
    
    useEffect(() =>{
      setDataL(subscribersData);
    }, [subscribersData])


    return(
      <div className="subscribers subscribers-box box"> 
        <div>
          <button onClick={fetchList} className='requestBtn load-btns'>Get Filtered list</button>
          <div className='input-areas' style={{textAlign: "left"}}>
                      <label>Decoder ID</label>
                      <input placeholder="Find by decoder_id" className='inputs' type="text" onChange={(e) => {fillForms("decoder_id", e.target.value)}}/>
          </div>
        </div>
        <div>
          <table>
            <thead>
              <tr>
                <TableHeader setType={setRegionId} regions={regions} fillForms={fillForms} columns={(selfRightsLvl < 128 ? two(selfRightsLvl) : true) ? columnsR : columns}/>
              </tr>
            </thead>
            <tbody>
              <TableRows regions={regions} domain={domain} fetchList={fetchList} subscribersData={subscribersData} columns={ (selfRightsLvl < 128 ? two(selfRightsLvl) : true) ? columnsR : columns} handleShowUserInfo={handleShowUserInfo}/>
            </tbody>  
          </table>
          <Pagination pageNumber={pageNumber} pageCount={pageCount} setPageNumber={(param) => {setPageNumber(param)}}/> 
        </div>
        {(selfRightsLvl < 128 ? two(selfRightsLvl) : true) && <AddUser regions={regions} domain={domain} fetchList={fetchList} pageNumber={pageNumber}/>}
        {info && <UserInfoTable userData={user} newBalance={balance} fetchList={fetchUserData} index={userId}/>} 
        {info && <UserDecodersList domain={domain} userId={userId}/>} 
        {info && (selfRightsLvl < 128 ? four(selfRightsLvl) : true) && <button onClick={paymentsState} className='requestBtn load-btns'>{!showPayments ? 'Show payments' : 'Close'}</button> }
        {showPayments && <Payments setBalance={setBalance} domain={domain}  selfRightsLvl={selfRightsLvl} email={user.email || ''} dataL={payments} setDataL={setPayments} id={userId} currencies={currenciesL}/>}
      </div>
    )
}


export default Subscribers;